<div class="view-help" #viewHelp gaCategory="View Help">
  <div class="view-help__inner" [ngSwitch]="activeTab">
    <!-- Close -->
    <div
      gaEvent
      gaAction="Clicked Close Help"
      class="view-help__close"
      (click)="handleCloseClick()">
      <app-icon icon="times"></app-icon>
    </div>

    <!-- Tabs -->
    <div class="view-help__tabs">
      <div
        gaEvent
        gaAction="Clicked Navigation Basics"
        class="view-help__tab"
        role="button"
        (click)="handleTabClick(helpTypeEnum.Basics)"
        [ngClass]="{'view-help__tab--active': activeTab === helpTypeEnum.Basics}">
        Navigation Basics
      </div>

      <div
        gaEvent
        gaAction="Clicked All Controls"
        class="view-help__tab"
        role="button"
        (click)="handleTabClick(helpTypeEnum.All)"
        [ngClass]="{'view-help__tab--active': activeTab === helpTypeEnum.All}">
        All Controls
      </div>

      <div
        gaEvent
        gaAction="Clicked Keyboard Shortcuts"
        class="view-help__tab"
        role="button"
        (click)="handleTabClick(helpTypeEnum.Shortcuts)"
        [ngClass]="{'view-help__tab--active': activeTab === helpTypeEnum.Shortcuts}">
        Keyboard Shortcuts
      </div>
    </div>

    <!-- Basics -->
    <ng-container *ngSwitchCase="helpTypeEnum.Basics">

      <!-- Mouse controls -->
      <div class="view-help__group">
        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-rotate.svg)'"></div>
          <div class="view-help__label">Rotate</div>
          Click and drag or use one finger to change the viewing angle.
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-pan.svg)'"></div>
          <div class="view-help__label">Pan</div>
          Hold the shift key and drag or use two fingers to move the model's position.
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-zoom.svg)'"></div>
          <div class="view-help__label">Zoom</div>
          Scroll up and down or pinch with two fingers to zoom in or out.
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-learn.svg)'"></div>
          <div class="view-help__label">Explore the Anatomy</div>
          Click or tap an anatomic structure or label to learn more.
        </div>
      </div>
    </ng-container>

    <!-- All controls -->
    <ng-container *ngSwitchCase="helpTypeEnum.All">
      <!-- Mouse -->
      <div class="view-help__header">
        Mouse
      </div>

      <div class="view-help__group">
        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-mouse-hold-left.svg)'"></div>
          Hold left button to rotate
        </div>

        <div class="view-help__item">
            <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-mouse-hold-right.svg)'"></div>
          Hold right button to pan
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-mouse-single-click-left.svg)'"></div>
          Single-click left button to select a structure
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-mouse-double-click-left.svg)'"></div>
          Double-click left button to auto-focus on a structure
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-mouse-long-press-left.svg)'"></div>
          Long-click to fly to a structure
        </div>
      </div>

      <!-- Keyboard -->
      <div class="view-help__header">
        Keyboard
      </div>

      <div class="view-help__group">
        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-keyboard-rotate.svg)'"></div>
          Rotate with arrows
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-keyboard-pan.svg)'"></div>
          Pan up (W), left (A), down (S), right(D)
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-keyboard-zoom.svg)'"></div>
          Zoom out (-, C) and zoom in (+, E)
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-keyboard-slow-motion.svg)'"></div>
          Hold with any previous key to slow down motion
        </div>
      </div>

      <!-- Trackpad -->
      <div class="view-help__header">
        Trackpad
      </div>

      <div class="view-help__group">
        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-trackpad-single-tap.svg)'"></div>
          Single-tap to auto-focus a structure
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-trackpad-double-tap.svg)'"></div>
          Double-tap to select a structure
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-trackpad-long-press.svg)'"></div>
          Long-press to fly to a structure
        </div>

        <div class="view-help__item">
          <div class="view-help__image" [style.backgroundImage]="'url(assets/images/widget/help-trackpad-scroll.svg)'"></div>
          Scroll up and down to zoom
        </div>
      </div>

      <!-- In-App -->
      <div class="view-help__header">
        In-App
      </div>

      <div class="view-help__group">
        <div class="view-help__item">
          <app-icon class="view-help__icon" icon="plus"></app-icon>
          Zoom in
        </div>

        <div class="view-help__item">
          <app-icon class="view-help__icon" icon="minus"></app-icon>
          Zoom out
        </div>

        <div class="view-help__item">
          <app-icon class="view-help__icon" icon="location"></app-icon>
          Recenter 3D model
        </div>

        <div class="view-help__item">
          <app-icon class="view-help__icon" icon="arrows"></app-icon>
          Pan
        </div>
      </div>
    </ng-container>

    <!-- Keyboard Shortcuts -->
    <ng-container *ngSwitchCase="helpTypeEnum.Shortcuts">
      <app-view-shortcuts></app-view-shortcuts>
    </ng-container>
  </div>
</div>
